"use strict";

exports.__esModule = true;
exports.default = void 0;

function getSelected(selectedItems, isMultiSelect, id) {
  if (selectedItems.includes(id)) {
    return selectedItems.filter(function (s) {
      return s !== id;
    });
  }

  if (isMultiSelect) {
    return [id].concat(selectedItems);
  }

  return [id];
}

var _default = getSelected;
exports.default = _default;